
import { motion, useSpring } from "framer-motion";
import { useEffect, useState } from "react";

const CustomCursor = () => {
  const [isHovering, setIsHovering] = useState(false);
  
  // Use springs for smoother animation and better performance
  const x = useSpring(0, { stiffness: 700, damping: 35 });
  const y = useSpring(0, { stiffness: 700, damping: 35 });

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      // Update spring values directly for smoother animation
      x.set(e.clientX - 10);
      y.set(e.clientY - 10);
    };

    const handleMouseOver = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isClickable = 
        target.tagName === 'A' || 
        target.tagName === 'BUTTON' ||
        target.closest('a') !== null ||
        target.closest('button') !== null ||
        target.closest('.bento-card') !== null ||
        target.classList.contains('bento-card');

      setIsHovering(isClickable);
    };

    // Use passive event listeners for better performance
    window.addEventListener("mousemove", handleMouseMove, { passive: true });
    document.addEventListener("mouseover", handleMouseOver, { passive: true });
    document.addEventListener("mouseout", () => setIsHovering(false), { passive: true });

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mouseout", () => setIsHovering(false));
    };
  }, [x, y]);

  return (
    <motion.div
      className="fixed top-0 left-0 w-5 h-5 bg-white rounded-full pointer-events-none z-[9999] mix-blend-difference"
      style={{ 
        x, 
        y,
        scale: isHovering ? 1.5 : 1 
      }}
      transition={{
        scale: {
          type: "spring",
          stiffness: 900,
          damping: 30,
          mass: 0.2
        }
      }}
    />
  );
};

export default CustomCursor;
